import styled from "styled-components";

export const Container = styled.div`
  width: max-content;

  & > form {
    width: 100%;
    height: 100%;

    & > *:not(:last-child) {
      margin-bottom: 20px;
    }
  }
`;

export const GroupFields = styled.section`
  display: flex;
  flex-direction: column;

  & > *:not(:last-child) {
    margin: 0 0 10px 0;
  }

  @media screen and (min-width: 800px) {
    flex-direction: row;

    input {
      min-width: 150px !important;
      width: 100%;
    }

    & > :not(:last-child) {
      margin: 0 50px 0 0;
    }
  }
`;

export const GroupButtons = styled(GroupFields)`
  button {
    width: 100% !important;
  }

  & > *:not(:last-child) {
    margin: 0 0 20px 0;
  }

  @media screen and (min-width: 800px) {
    button {
      min-width: 150px !important;
    }

    & > :not(:last-child) {
      margin: 0 50px 0 0;
    }
  }
`;

export const Fieldset = styled.fieldset`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14.4px;
  width: 100%;

  & > label {
    font-weight: 600;
  }

  & > input {
    border: 1px solid #c4c4c4;
    border-radius: var(--border-radius);
    min-height: 40px;
    min-width: 450px;
    width: 100%;
    padding: 5px 5px 5px 15px;

    @media screen and (max-width: 800px) {
      min-width: 220px;
      width: 100%;
    }
  }

  & > textarea {
    border: 1px solid #c4c4c4;
    border-radius: var(--border-radius);
    min-height: 40px;
    min-width: 450px;
    width: 100%;
    resize: vertical;
    padding: 5px 15px 5px 15px;

    @media screen and (max-width: 800px) {
      min-width: 220px;
      width: 100%;
    }
  }

  & > *:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const Button = styled.button`
  align-self: center;
  padding: 1rem;
  background-color: var(--color-primary);
  border-radius: var(--border-radius);
  border: 1px var(--color-primary) solid;
  color: #fff;
  width: max-content;
  cursor: pointer;
  transition: var(--transition);

  &:hover {
    border: 1px var(--color-primary) solid;
    color: var(--color-primary);
    background-color: transparent;
  }

  ${(props) => {
    if (props.kind === "positive") {
      return `
          background-color: var(--color-primary);
          color: #fff;
          border: 1px var(--color-primary) solid;

          &:hover{
            border: 1px var(--color-primary) solid;
            color: var(--color-primary);
            background-color: transparent;
          }
        `;
    }

    if (props.kind === "negative") {
      return `
          border: 1px var(--color-primary) solid;
          color: var(--color-primary);
          background-color: transparent;

          &:hover{
            background-color: var(--color-primary);
            color: #fff;
            border: 1px var(--color-primary) solid;
          }
        `;
    }
  }}
`;
